export interface ActivityRenderer {
  render(): any;
}

export function isRenderer(value: any): value is ActivityRenderer {
  return (value as ActivityRenderer).render !== undefined;
}
